<script setup>
import { onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import {atlassianServiceStatusUrl} from "@/common/constants";

const SCRIPT_SRC = atlassianServiceStatusUrl
let tag

function injectScript () {
  if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return
  if (!isProdEnv) return

  tag = document.createElement('script')
  tag.setAttribute('src', SCRIPT_SRC)
  tag.setAttribute('async', 'true')
  document.head.appendChild(tag)
}

const { appContext } = getCurrentInstance()
const isProdEnv = appContext.config.globalProperties.$isProdEnv

onMounted(injectScript)

onBeforeUnmount(() => {
  //to remove the component after unmount the page
  if (tag && tag.parentNode) tag.parentNode.removeChild(tag)
})
</script>
<template>
  <!-- target div for Atlassian markup -->
  <div aria-hidden="true"></div>
</template>